import { PromptCategory } from '../enums/prompt.enum'

/** Labels de catégorie pour l'affichage */
export const CATEGORY_LABELS: Record<
  PromptCategory,
  { label: string; emoji: string; color: string }
> = {
  [PromptCategory.WRITING]: { label: 'Rédaction', emoji: '✍️', color: '#3b82f6' },
  [PromptCategory.CODING]: { label: 'Code', emoji: '💻', color: '#22c55e' },
  [PromptCategory.MARKETING]: { label: 'Marketing', emoji: '📈', color: '#f59e0b' },
  [PromptCategory.PRODUCTIVITY]: { label: 'Productivité', emoji: '⚡', color: '#8b5cf6' },
  [PromptCategory.ANALYSIS]: { label: 'Analyse', emoji: '📊', color: '#06b6d4' },
  [PromptCategory.CREATIVE]: { label: 'Créativité', emoji: '🎨', color: '#ec4899' },
  [PromptCategory.BUSINESS]: { label: 'Business', emoji: '💼', color: '#14b8a6' },
  [PromptCategory.EDUCATION]: { label: 'Éducation', emoji: '🎓', color: '#f97316' },
  [PromptCategory.ADMIN_LEGAL]: { label: 'Démarches & juridique', emoji: '⚖️', color: '#6366f1' },
  [PromptCategory.REAL_ESTATE]: { label: 'Immobilier & habitat', emoji: '🏠', color: '#0ea5e9' },
  [PromptCategory.CONSTRUCTION]: { label: 'Bâtiment & travaux', emoji: '🏗️', color: '#f97316' },
  [PromptCategory.EXECUTIVE_ASSISTANT]: {
    label: 'Assistant de direction',
    emoji: '🗂️',
    color: '#8b5cf6',
  },
  [PromptCategory.FINANCE_ACCOUNTING]: { label: 'Finance & compta', emoji: '💶', color: '#10b981' },
  [PromptCategory.HR_CAREER]: { label: 'RH & carrière', emoji: '👥', color: '#f43f5e' },
  [PromptCategory.SALES]: { label: 'Vente', emoji: '🤝', color: '#f59e0b' },
  [PromptCategory.CUSTOMER_SUPPORT]: { label: 'Support client', emoji: '🎧', color: '#06b6d4' },
  [PromptCategory.OPERATIONS]: { label: 'Opérations', emoji: '⚙️', color: '#64748b' },
  [PromptCategory.PERSONAL_LIFE]: { label: 'Vie pratique', emoji: '🏡', color: '#84cc16' },
  [PromptCategory.CUSTOM]: { label: 'Autre', emoji: '🔧', color: '#6b7280' },
}

/** AI model labels */
export const AI_MODEL_LABELS = {
  GPT4: { label: 'GPT-4', icon: '🟢' },
  CLAUDE: { label: 'Claude', icon: '🟣' },
  GEMINI: { label: 'Gemini', icon: '🔵' },
  MISTRAL: { label: 'Mistral', icon: '🟠' },
  UNIVERSAL: { label: 'Universel', icon: '⚪' },
} as const

/** Nombre initial de prompts cible pour la v1 */
export const INITIAL_PROMPTS_TARGET = 30
